import React, { Component } from 'react'
import { get, omit, pick } from 'lodash'
import { message } from 'antd'
import LabourContracts from '../../../../../../api/People/LabourContracts'
import withLoadingSection from '../../../../../../elements/HOC/withLoadingSection'
import Templates from '../../../../../../api/Templates'
import WorkOrders from '../../../../../../components/People/Member/Contract/ViewContract/WorkOrders/WorkOrders'
import { idMaker } from '../../../../../../modules/Utils'
import Employees from '../../../../../../api/Employees'
import logProps from '../../../../../../elements/HOC/logProps'

class WorkOrdersCont extends Component {
  constructor (props) {
    super(props)
    this.state = {
      submitting: false,
      current: 2,
      workOrder: { rates: [] },
      list: [],
      contract: props.owner,
      keyAtr: 'key',
      employee: props.employee,
      member: props.member,
    }
  }

  componentDidMount () {
    this.fetch()
  }

  templateApi = new Templates()
  employeesApi = new Employees()
  api = new LabourContracts()
  ids = idMaker()
  keyTermsRef = React.createRef()
  workingConditionsRef = React.createRef()
  compensationRef = React.createRef()

  fetch = async () => {
    try {
      this.setState({ fetching: true })
      const { props } = this
      let list = await this.api.workOrder.list(get(props, 'owner._key', 'all'))
      this.setState({ data: list, list, fetching: false })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }
  next = async () => {
    let valid = false
    switch (this.state.current) {
      case 0:
        valid = await this.checkKeyTermsForm()
        break
      case 1:
        valid = await this.checkWorkingConditionsForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current })
    }
  }
  submit = async () => {
    let valid = false
    try {
      valid = await this.checkCompensationForm()
      if (valid) {
        this.setState({ submitting: true })
        let { workOrder } = this.state
        workOrder = {
          ...workOrder,
          contract: pick(this.state.contract, ['_id', 'code']),
        }
        await this.api.workOrder.create(workOrder)
        message.success('Created !')
        this.handleCancel()
        this.fetch()
      }
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({ submitting: false })
    }
  }
  update = async () => {
    let valid = false
    try {
      valid = await this.checkCompensationForm()
      if (valid) {
        this.setState({ submitting: true })
        let { workOrder } = this.state
        workOrder = {
          ...workOrder,
          contract: pick(this.state.contract, ['_id', 'code']),
        }
        workOrder = omit(workOrder, ['_history', 'status', 'code', 'revision'])
        await this.api.workOrder.update(workOrder)
        this.setState({ submitting: false })
        message.success('Updated')
        this.handleCancel()
        this.fetch()
      }
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({ submitting: false })
    }
  }

  handleCancel = () => {
    this.setState({ visible: false })
  }
  checkKeyTermsForm = () => {
    return new Promise((res, rej) => {
      this.keyTermsRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  checkCompensationForm = () => {
    return new Promise((res, rej) => {
      this.compensationRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  checkWorkingConditionsForm = () => {
    return new Promise((res, rej) => {
      this.workingConditionsRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            workOrder: Object.assign({}, this.state.workOrder, values),
          })
          res(true)
        }
      })
    })
  }
  updateWorkOrder = (attribute, value) => {
    const workOrder = this.state.workOrder
    this.setState({
      workOrder: Object.assign({}, workOrder, { [attribute]: value }),
    })
  }
  onEdit = (workOrder = {}, type = 'new') => {
    this.setState({ visible: true, workOrder, type })
  }
  onCancel = () => {
    this.setState({ visible: false })
  }
  add = () => {
    const { workOrder } = this.state
    const newData = workOrder.rates ? [...workOrder.rates] : []
    newData.push({ [this.state.keyAtr]: this.ids.next().value, editable: true })
    this.setState((prvState) => ({
      workOrder: { ...prvState.workOrder, rates: newData },
    }))
  }
  cancel = (_key) => {
    const { workOrder } = this.state
    const newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === [this.state.keyAtr])
        this.remove(target[this.state.keyAtr])
      else
        this.setState((prvState) => ({
          workOrder: { ...prvState.workOrder, rates: newData },
        }))
    }
  }
  remove = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    newData = newData.filter((item) => _key !== item[this.state.keyAtr])
    this.setState((prvState) => ({
      workOrder: { ...prvState.workOrder, rates: newData },
    }))
  }
  edit = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      target.editable = true
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }
  save = (_key) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.find((item) => _key === item[this.state.keyAtr])
    if (target) {
      delete target.editable
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }
  handleChange = (value, _key, column) => {
    const { workOrder } = this.state
    let newData = [...workOrder.rates]
    const target = newData.filter((item) => _key === item[this.state.keyAtr])[0]
    if (target) {
      target[column] = value
      this.setState((prvState) => ({
        workOrder: { ...prvState.workOrder, rates: newData },
      }))
    }
  }

  render () {
    return (
      <WorkOrders
        {...this.state}
        {...this.props}
        {...pick(this, [
          'fetch',
          'fetchRatesTemplate',
          'fetchUOM',
          'fetchPayPeriod',
          'prev',
          'next',
          'submit',
          'update',
          'onEdit',
          'onCancel',
          'add',
          'cancel',
          'remove',
          'edit',
          'save',
          'handleChange',
          'keyTermsRef',
          'workingConditionsRef',
          'compensationRef',
        ])}
      />
    )
  }
}

WorkOrdersCont.propTypes = {}
WorkOrdersCont.defaultProps = {}

export default logProps(withLoadingSection(WorkOrdersCont))
